"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _AddFolderModal = _interopRequireDefault(require("FileManagerCore/components/AddFolderModal"));

var _ScopedFeatureTooltip = _interopRequireDefault(require("FileManagerCore/components/permissions/ScopedFeatureTooltip"));

var AddFolderButton = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AddFolderButton, _Component);

  function AddFolderButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AddFolderButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AddFolderButton).call(this, props));
    _this.state = {
      open: false
    };
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCreate = _this.handleCreate.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClose = _this.handleClose.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(AddFolderButton, [{
    key: "handleClick",
    value: function handleClick() {
      this.setState({
        open: !this.state.open
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.setState({
        open: false
      });
    }
  }, {
    key: "handleCreate",
    value: function handleCreate(folderName) {
      var _this$props = this.props,
          onCreate = _this$props.onCreate,
          selectedFolder = _this$props.selectedFolder;
      onCreate(folderName, selectedFolder);
      this.setState({
        open: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          folders = _this$props2.folders,
          children = _this$props2.children,
          use = _this$props2.use,
          className = _this$props2.className,
          isReadOnly = _this$props2.isReadOnly;
      var open = this.state.open;
      return _react.default.createElement("span", null, _react.default.createElement(_ScopedFeatureTooltip.default, {
        placement: "left"
      }, _react.default.createElement(_UILink.default, {
        className: className,
        use: use,
        onClick: this.handleClick,
        "data-test-id": "add-folder",
        disabled: isReadOnly
      }, children)), open && _react.default.createElement(_AddFolderModal.default, {
        objects: folders,
        onClose: this.handleClose,
        onCreate: this.handleCreate
      }));
    }
  }]);
  return AddFolderButton;
}(_react.Component);

exports.default = AddFolderButton;
AddFolderButton.propTypes = {
  className: _propTypes.default.string,
  use: _UILink.default.propTypes.use,
  folders: _propTypes.default.instanceOf(_immutable.default.List).isRequired,
  onCreate: _propTypes.default.func.isRequired,
  selectedFolder: _propTypes.default.instanceOf(_immutable.default.Map),
  children: _propTypes.default.node.isRequired,
  isReadOnly: _propTypes.default.bool.isRequired
};
AddFolderButton.defaultProps = {
  use: 'blue',
  isReadOnly: false
};
module.exports = exports.default;